import {Form} from 'antd'
import meta from './metaDm.mjs'
import Select from './SelectDm.jsx'

export const FormItemDm = props => (
    <Form.Item
        label={meta.name}
        name="dm"
        {...props}
    >
        <Select />
    </Form.Item>
)

export const FormItemDms = props => (
    <Form.Item
        label={meta.name}
        name="dms"
        {...props}
    >
        <Select multiple />
    </Form.Item>
)
